<template>
  <div>
    <Dialog title="修护审核详情" :hide="dialogVisible" @handleClick="changeClose">
      <div slot="header">修护审核详情</div>
      <div slot="body">
        <el-form ref="audit" :model="audit" label-width="110px" label-position="right">
          <el-form-item label="修护门店：">{{ auditForm.shopIdCn }}</el-form-item>
          <el-form-item label="修护技师：">{{ auditForm.staffIdCn }}</el-form-item>
          <el-form-item label="修护状态：">{{ auditForm.auditStatusCn }}</el-form-item>
          <el-form-item label="修护时间：">{{ formatDate(auditForm.repairTime) }}</el-form-item>
          <el-form-item label="修护照片：">
            <el-image
              :src="item"
              v-for="(item,index) in auditForm.imgUrlList"
              :key="index"
              class="mr10"
              :preview-src-list="auditForm.imgUrlList"
              style="width: 80px;height: 80px;"
            ></el-image>
          </el-form-item>
          <el-form-item label="备注：" v-if="auditForm.remark">{{ auditForm.remark }}</el-form-item>
          <el-form-item label="审核结果：" prop="auditStatus" :rules="$rules.required">
            <el-radio-group v-model="audit.auditStatus" class="flex flex-row audit-set">
              <el-radio label="pass">审核通过</el-radio>
              <el-radio label="refuse">审核不通过</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="拒绝原因：" :rules="$rules.required" v-if="audit.auditStatus == 'refuse'">
            <el-input type="textarea" v-model.trim="audit.auditRemark"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="saveAudit">确定</el-button>
      </div>
    </Dialog>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import Dialog from "../../../components/common/dialog.vue";
export default {
  data() {
    return {
      dialogVisible: false,
      list: [],
      auditForm: {},
      audit: {
        id: "",
        auditStatus: "pass",
        auditRemark: ""
      }
    };
  },
  mixins: [minxin],
  components: { Dialog },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.$on("set", function(row) {
        this.dialogVisible = true;
        this.auditForm = row;
        this.auditRemark = "";
        this.audit.id = row.id;
      });
    },
    changeClose(show) {
      this.dialogVisible = false;
      this.$emit("change", false);
    },
    saveAudit() {
      if (this.audit.auditStatus == "refuse") {
        if (this.audit.auditRemark == "") {
          this.$message.warning("请输入拒绝原因");
          return false;
        }
      } else {
        this.audit.auditRemark = "";
      }
      this.$api.post(this.$url.repairRecord.audit, this.audit).then(res => {
        if (res) {
          this.$message.success("操作成功");
          this.dialogVisible = false;
          this.$emit("change", true);
        }
      });
    }
  }
};
</script>

<style>
.el-message-box__input .el-input {
  width: 100%;
}
</style>

<style scoped lang="less">
@import "../../../assets/css/edit.less";
.pay-mains {
  .img {
    width: 80px;
    height: 80px;
    margin: 0 10px 10px 0;
  }
  .blue {
    color: @blue;
  }
  .red {
    color: @red;
  }
}
.audit-set {
  height: 40px;
}
</style>